import {CustomerAddress} from "@biletix/core/models/customer/customer-address.model";

export class EditCustomerAddressData {

  address?: CustomerAddress | any;

  /**
   * editMode:true ise adress düzenleme false ise address ekleme anlamına gelir.
   */
  editMode?: boolean = false;

  /**
   * isDeliveryAddress=true ise normal adress false ise  fatura adresi anlamına gelir.
   */
  isDeliveryAddress: boolean = true;


  constructor(init?: EditCustomerAddressData) {
    this.address = init?.address;
    this.isDeliveryAddress = init?.isDeliveryAddress ?? true;
    if (init?.address) {
      this.editMode = true;
    }
  }
}
